import { Component } from '@angular/core';

@Component({
  selector: 'app-reject-highlight',
  imports: [],
  templateUrl: './reject-highlight.html',
    styleUrl: './reject-highlight.scss',
})
export class RejectHighlight {

}
